import {
  Box,
  Button,
  IconButton,
  Link,
  Stack,
  Tooltip,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import AppButton from "../../components/app-button/AppButton";
import AppDialogDelete from "../../components/app-dialog-delete/AppDialogDelete";
import AppTable from "../../components/app-table/AppTable";
import Iconify from "../../components/iconify/Iconify";
import {
  addonAction,
  addonDelete,
  getAddons,
} from "../../reduxStore/slices/addonSlice";
import { useNotify } from "../../utils/snackbarUtils";

function AddonsList(props) {
  const tableHead = [
    { id: "name", label: "Addon Name", align: "left" },
    { id: "price", label: "Price", align: "center" },
    { id: "addonGroup", label: "Addon Group", align: "left" },
    { id: "status", label: "Status", align: "center" },
    { id: "createdAt", label: "Created At", align: "left" },
    { id: "actions", label: "Actions", align: "center", width: "120px" },
  ];

  const { showSuccess, handleApiError, showError } = useNotify();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { user } = useSelector((state) => state.auth);
  const { list, loading: isLoading } = useSelector((state) => state.addon);

  const storeId = user?.storeId;
  const tableRows = list;

  const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false);
  const [selectedRow, setSelectedRow] = useState({});

  const getAllAddons = async () => {
    try {
      await dispatch(getAddons({ storeId })).unwrap();
    } catch (err) {
      handleApiError(err);
    }
  };

  // Load addons
  useEffect(() => {
    if (storeId) {
      getAllAddons();
    }
  }, [storeId]);

  const handleAddAddons = () => {
    navigate("/app/config/addon/add");
  };

  const handleDeleteClose = () => {
    setIsDeleteDialogOpen(false);
  };

  const toggleStatus = async (event, row) => {
    const obj = {
      store_id: storeId,
      uid: row.uid,
      id: row.id,
      record_status: event.target.value === "A" ? "D" : "A",
    };
    try {
      const res = await dispatch(addonAction(obj)).unwrap();
      showSuccess(res.message);
    } catch (err) {
      handleApiError(err);
    }
  };

  const handleDeleteConfirm = async () => {
    setIsDeleteDialogOpen(false);
    const obj = {
      store_id: storeId,
      uid: selectedRow.uid,
      id: selectedRow.id,
      record_status: "R",
    };
    try {
      const res = await dispatch(addonDelete(obj)).unwrap();
      showSuccess(res.message);
    } catch (err) {
      handleApiError(err);
    }
  };

  const editActionClick = (e, row) => {
    setSelectedRow(row);
    navigate(`/app/config/addon/edit/${row.uid}`);
  };

  const deleteActionClick = async (event, row) => {
    setIsDeleteDialogOpen(true);
    setSelectedRow(row);
  };

  return (
    <Box
      sx={{
        margin: "25px 60px",
      }}
    >
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        mb={3}
      >
        <Stack direction="row" alignItems="center" spacing={2}>
          <Tooltip title="Back to Configuration">
            <IconButton onClick={() => navigate("/app/config")}>
              <Iconify icon="eva:arrow-back-fill" width={24} height={24} />
            </IconButton>
          </Tooltip>

          <Typography variant="h5" gutterBottom>
            Addons
          </Typography>
        </Stack>
        <Link style={{ textDecoration: "none" }}>
          {tableRows.length > 0 && !isLoading && (
            <AppButton
              onClick={handleAddAddons}
              variant="contained"
              startIcon={<Iconify icon="eva:plus-fill" />}
            >
              New Addon
            </AppButton>
          )}
        </Link>
      </Stack>
      <Box>
        <AppTable
          tableHead={tableHead}
          tableRows={tableRows}
          listType="addonsTables"
          searchPlaceholder="Search By Addon Name"
          toggleSwitchStatus={toggleStatus}
          editActionClick={editActionClick}
          deleteActionClick={deleteActionClick}
          searchField={"name"}
          handleAddAction={handleAddAddons}
          emptyTitle="No addons available"
          emptyDesc="Add new addon to get started."
          emptyButtonLabel="New Addon"
          isLoading={isLoading}
        />
      </Box>

      {isDeleteDialogOpen && (
        <AppDialogDelete
          isOpen={isDeleteDialogOpen}
          id={"delete_addon_dialog"}
          title={<>Delete Addon</>}
          footer={
            <>
              <Button
                autoFocus
                onClick={handleDeleteConfirm}
                className="confirm-delete-btn"
              >
                Delete
              </Button>
              <Button
                onClick={handleDeleteClose}
                variant="outlined"
                className="cancel-delete-btn"
              >
                Cancel
              </Button>
            </>
          }
        >
          <Typography
            style={{
              fontSize: 14,
              color: "#000",
            }}
          >
            Are you sure want to delete Addon?
          </Typography>
        </AppDialogDelete>
      )}
    </Box>
  );
}

export default AddonsList;
